module.exports = __webpack_public_path__ + "img/text.69ed5d55.png";